import React, { PropTypes } from 'react';
import './closeButton.css';

const propTypes = {
  handleClose: PropTypes.func.isRequired,
};

const CloseButton = ({ handleClose }) => {
  return (
    <div onClick={handleClose} className="ui right floated big black back button">
      OK
    </div>
  );
};

CloseButton.propTypes = propTypes;

export default CloseButton;



/** WEBPACK FOOTER **
 ** ./src/components/layout/closeButton/CloseButton.js
 **/